import { useEffect, useRef } from "preact/hooks";
import {
  // useOverlay,
  // usePreventScroll,
  useModal,
  OverlayContainer,
} from "@react-aria/overlays";
import { useDialog } from "@react-aria/dialog";
import { ExternalIcon, BuyMeACoffeeIcon } from "../../../components/Icons";

const DonationModal = ({ onClickedNo, ...props }) => {
  let ref = useRef();

  let { modalProps } = useModal();
  // Get props for the dialog and its title
  let { dialogProps, titleProps } = useDialog(props, ref);

  useEffect(() => {
    const handleEscapePress = (e) => {
      if (e.key === "Escape") {
        onClickedNo();
      }
    };

    document.addEventListener("keydown", handleEscapePress);
    return () => {
      document.removeEventListener("keydown", handleEscapePress, true);
    };
  });

  return (
    <OverlayContainer>
      <div
        ref={ref}
        {...dialogProps}
        {...modalProps}
        class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center"
      >
        <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50" />

        <div class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
          <div class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
            <svg
              class="fill-current text-white"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
            </svg>
            <span class="text-sm">(Esc)</span>
          </div>
          <div class="modal-content py-4 text-left px-6">
            <div class="flex justify-between items-center pb-3">
              <h2 class="h2 font-bold" {...titleProps}>
                Enjoy your windrose!
              </h2>
              <button
                onClick={onClickedNo}
                class="modal-close cursor-pointer z-50"
              >
                <svg
                  class="fill-current text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
                </svg>
              </button>
            </div>
            <h3 class="h3 text-indigo-500">Donate!</h3>
            <p>
              If this website has saved you the frustration of having to work
              with shoddy Excel templates or other headache inducing tools, then
              please donate or buy be me coffee to keep this site up and running
              and support development, this way WindRose.xyz can stay ad-free!
            </p>
            <div class="flex justify-end pt-2">
              <button
                onClick={onClickedNo}
                class="px-4 bg-transparent p-3 rounded-lg text-indigo-500 hover:bg-gray-300"
              >
                No thank you
              </button>
              <button class="px-4 text-bold bg-indigo-500 text-white p-3 rounded-lg  hover:bg-gray-100 hover:text-indigo-400 mr-2">
                <a
                  rel="noopener noreferrer"
                  href="https://www.buymeacoffee.com/OfU1nAuiI"
                >
                  <BuyMeACoffeeIcon />
                  <span class="ml-2">Buy me a coffee</span>
                </a>
              </button>
              <button class="px-4 text-bold bg-indigo-500 text-white p-3 rounded-lg  hover:bg-gray-100 hover:text-indigo-400 mr-2">
                <a
                  class="donate"
                  role="button"
                  href="https://paypal.me/BlomJ"
                  rel="noopener noreferrer"
                  title="Donate via PayPal"
                >
                  Donate via PayPal
                  <ExternalIcon />
                </a>
              </button>
            </div>
            <h3 class="h3 text-indigo-500">Feedback</h3>
            <p class="mt-2">
              If you are not able to donate then please provide feedback on
              whether WindRose.xyz was useful or what would make more useful for
              you.
              <button class="px-4 text-bold bg-indigo-500 text-white p-3 rounded-lg  hover:bg-gray-100 hover:text-indigo-400 mr-2">
                <a
                  class="donate"
                  role="button"
                  href="/feedback"
                  title="Go to the feedback page"
                >
                  Give feedback
                </a>
              </button>
            </p>
          </div>
        </div>
      </div>
    </OverlayContainer>
  );
};

export { DonationModal };
